import { useBoundStore } from "store";

// Reads a per-tenant feature flag from the tenant's settings.features blob (loaded
// with the tenant). Returns false when the tenant, its settings, or the flag is
// absent. The API enforces the same flag server-side — this only controls rendering.
export const useFeatureFlag = (feature: string): boolean => {
  const { tenant } = useBoundStore();
  return tenant?.settings?.features?.[feature] === true;
};
